import Config from '../../config/index'

import Sto from 'store'

import axios from './filterHttp' //'axios'

import qs from 'qs'

import CryptoJS from '../../helper/encrypt'
import router from './../../router/router';

let time = 0

const api = async (url = '', data = {}, type = 'POST') => {

	// 登录用户TOKEN
	let token = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : ''

	// 登录用户的ID
	let userid = localStorage.getItem('userid') ? localStorage.getItem('userid') : ''

	axios.defaults.headers = {
		'UUID': userid,
		'token': token,
		'Content-Type': 'application/json'
	}

	let res = {}
	if (type == 'POST') {
		// let params = qs.stringify(data)
		res = axios.post(url, data)

	} else {
		return new Promise((resolve, reject) => {
			reject()
		})
		// let params = qs.stringify(data)
		res = axios.get(url, {
			params: data
		})
	}
	// return res;


	return new Promise((resolve, reject) => {

		res.then((request) => {
				if (request.data.header.code == 202) {

					if (++time == 2) {
						reject(request)
						return false
					}
					api('get_tcode',{type:2}).then((resJson) => {
						let x = resJson.data.body
						localStorage.setItem('userToken', x.token);
						var tokenTime = new Date().getTime()
						localStorage.setItem('tokenTime', tokenTime);
						// 重新执行原有

						api(url, data).then(r => {
							resolve(r)
						}).catch((r) => {
							reject(r)
							console.log(r)
						})
					})
				} else {
					resolve(request)
				}
			})
			.catch((response) => {
				reject(response)
			})

	})
}

// token过期的话，自动去更新
export default api



// WEBPACK FOOTER //
// ./src/api/fetch/api.js